import { render, staticRenderFns } from "./ConfiguratorLevel3Desktop.vue?vue&type=template&id=030875cc&"
import script from "./ConfiguratorLevel3Desktop.vue?vue&type=script&lang=js&"
export * from "./ConfiguratorLevel3Desktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports